module.exports = __webpack_public_path__ + "img/file-earmark-break.b2f005c2.svg";